// services/apiService.js/////

const commonHeaders = {
    'Content-Type': 'application/json',
  };
  
  // Utility function to add authorization header
  const withAuth = (token) => ({
    ...commonHeaders,
    Authorization: `Bearer ${token}`,
  });
  
  // GET request
  export const get = async (url, token = null) => {
    const res = await fetch(url, {
      method: 'GET',
      headers: token ? withAuth(token) : commonHeaders,
    });
    return await res.json();
  };
  
  // POST request
  export const post = async (url, body = {}, token = null) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: token ? withAuth(token) : commonHeaders,
      body: JSON.stringify(body),
    });
    return await res.json();
  };
  
  // PUT request
  export const put = async (url, body = {}, token = null) => {
    const res = await fetch(url, {
      method: 'PUT',
      headers: token ? withAuth(token) : commonHeaders,
      body: JSON.stringify(body),
    });
    return await res.json();
  };
  
  // PATCH request
  export const patch = async (url, body = {}, token = null) => {
    const res = await fetch(url, {
      method: 'PATCH',
      headers: token ? withAuth(token) : commonHeaders,
      body: JSON.stringify(body),
    });
    return await res.json();
  };
  
  // DELETE request
  export const del = async (url, token = null) => {
    const res = await fetch(url, {
      method: 'DELETE',
      headers: token ? withAuth(token) : commonHeaders,
    });
    return await res.json();
  };
  